import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TransactionRowText } from '@app/payments/models/payment-transaction';
import {
  PaymentTransactionsViewModel,
  Status,
  TransactionType,
} from '@usf/payment-types';

@Component({
  template: '',
})
export class TransactionRowBaseComponent implements OnChanges {
  @Input() vm: PaymentTransactionsViewModel;
  @Input() selectable: boolean;
  @Input() translatorText: TransactionRowText;
  @Input() isPayable = false;
  @Input() isReview = false;
  @Input() shouldShowButtons = true;
  @Input() shouldShowFullPO = false;
  @Input() shouldHaveEditableAmount = false;
  @Input() canCancelPayment = false;
  @Input() showOrderNumber = false;

  @Output() moreOptionsClickEmitter: EventEmitter<{
    event: Event;
    transaction: PaymentTransactionsViewModel;
    showPayButton: boolean;
  }> = new EventEmitter();
  @Output()
  transactionRowClickEmitter = new EventEmitter<PaymentTransactionsViewModel>();
  @Output() paymentAmountChangeEmitter: EventEmitter<{
    paymentAmount: number;
    transaction: PaymentTransactionsViewModel;
    errors: ValidationErrors;
  }> = new EventEmitter();
  @Output()
  viewInvoiceClickEmitter = new EventEmitter<PaymentTransactionsViewModel>();
  @Output()
  editAmountClickEmitter = new EventEmitter<PaymentTransactionsViewModel>();

  TransactionType = TransactionType;
  Status = Status;
  readonly formatDate = 'M/d/yyyy';

  showPayButton = false;
  showButtons = false;
  showEditAmount = false;
  isCredit = false;
  constructor() {}

  ngOnChanges() {
    if (this.vm !== undefined) {
      this.showPayButton = this.isPayable && this.vm.isPayable;
      this.showButtons =
        this.shouldShowButtons &&
        ((!!this.vm.isr && Object.keys(this.vm.isr).length > 0) ||
          this.showPayButton ||
          this.canCancelPayment);
      this.showEditAmount =
        this.shouldHaveEditableAmount &&
        this.vm?.status !== Status.UNUSED &&
        this.vm?.status !== Status.PENDING &&
        this.vm?.status !== Status.PROCESSING &&
        this.vm?.status !== Status.AUTOPAY &&
        this.vm?.amountDue > 0;
      this.isCredit = this.vm?.transactionType?.includes(
        TransactionType.credit,
      );
    }
  }

  onTransactionRowClick() {
    this.transactionRowClickEmitter.emit(this.vm);
  }

  onMoreOptionClick(event?: Event) {
    this.moreOptionsClickEmitter.emit({
      event,
      transaction: this.vm,
      showPayButton: this.showPayButton,
    });
  }

  onEditAmountClick() {
    this.editAmountClickEmitter.emit(this.vm);
  }

  onViewInvoiceClick() {
    this.viewInvoiceClickEmitter.emit(this.vm);
  }

  updatePaymentAmount({
    paymentAmount,
    errors,
  }: {
    paymentAmount: number;
    errors: ValidationErrors;
  }) {
    this.paymentAmountChangeEmitter.emit({
      transaction: this.vm,
      paymentAmount,
      errors,
    });
  }

  get isColorRed() {
    return (
      this.vm?.status === Status.OVERDUE ||
      this.vm?.status === Status.PARTIALLY_PAID ||
      this.vm?.status === Status.PENDING ||
      this.vm?.status === Status.UNPAID ||
      this.vm?.status === Status.PROCESSING ||
      this.vm?.status === Status.CANCELLING
    );
  }
}
